import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ArrowCircleLeftSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ArrowCircleLeftSVG;
